import { render, staticRenderFns } from "./ComparePage.vue?vue&type=template&id=c3aac12c&scoped=true&"
import script from "./ComparePage.vue?vue&type=script&lang=js&"
export * from "./ComparePage.vue?vue&type=script&lang=js&"
import style0 from "./ComparePage.vue?vue&type=style&index=0&id=c3aac12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aac12c",
  null
  
)

export default component.exports